// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /src/components/DNSLookup/DNSLookup.css */

.dnslookup-container {
  max-width: 500px;
  margin: 10px auto;
  padding: 20px;
  background: #f0f4f8;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.dnslookup-title {
  text-align: center;
  margin-bottom: 10px;
  color: #34495e;
  font-weight: 700;
  font-size: 1.8rem;
}

.dnslookup-input {
  width: 100%;
  padding: 12px 15px;
  font-size: 1rem;
  border: 1.8px solid #3498db;
  border-radius: 6px;
  margin-bottom: 15px;
  transition: border-color 0.3s ease;
  box-sizing: border-box; /* padding এর কারণে উইডথ যেন বেড়ে না যায় */
}

.dnslookup-input:focus {
  outline: none;
  border-color: #2980b9;
}

.dnslookup-button {
  width: 100%;
  padding: 12px;
  font-weight: 600;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1.1rem;
  transition: background-color 0.3s ease;
}

.dnslookup-button:disabled {
  background-color: #95a5a6;
  cursor: not-allowed;
}

.dnslookup-button:hover:not(:disabled) {
  background-color: #2980b9;
}

.dnslookup-results {
  margin-top: 25px;
  background: white;
  border-radius: 6px;
  padding: 15px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dnslookup-record-type {
  margin-bottom: 20px;
}

.dnslookup-record-type h4 {
  color: #2c3e50;
  margin-bottom: 15px;
  border-bottom: 2px solid #3498db;
  padding-bottom: 6px;
  text-transform: uppercase;
  font-size: 0.9rem;
  letter-spacing: 1px;
}

.dnslookup-record-type ul {
  list-style-type: none; /* ডট সরিয়ে ফেলা হয়েছে */
  padding-left: 0;
  margin: 0;
}

/* IP Info, ISP Info, Location এর জন্য মেইন কার্ড */
.dnslookup-ip-item {
  margin-bottom: 15px;
  padding: 15px;
  background: #f8fafc;
  border-radius: 6px;
  border-left: 4px solid #3498db;
  font-size: 0.95rem;
  line-height: 1.8; /* লাইন স্পেসিং বাড়ানো হয়েছে */
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

/* প্রতিটা লাইনকে আলাদা ব্লকে রাখা */
.dnslookup-ip-item div {
  margin-bottom: 4px;
  display: flex;
  flex-wrap: wrap;
}

/* Label গুলোর জন্য স্টাইল (যেমন: IP Info:) */
.dnslookup-ip-item strong {
  color: #34495e;
  min-width: 100px; /* লেবেলগুলো যেন সমান লাইনে থাকে */
  display: inline-block;
}

.dnslookup-no-record {
  font-style: italic;
  color: #7f8c8d;
  padding: 10px 0;
}

.dnslookup-error {
  color: #e74c3c;
  font-weight: 700;
  text-align: center;
  padding: 10px;
}

/* MX বা অন্যান্য সিঙ্গেল লাইন রেকর্ডের জন্য */
.dnslookup-item-single {
  padding: 8px 12px;
  background: #f1f4f6;
  margin-bottom: 5px;
  border-radius: 4px;
  color: #2c3e50;
}`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/DNSLookup.css"],"names":[],"mappings":"AAAA,4CAA4C;;AAE5C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB,EAAE,0CAA0C;AACpE;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB,EAAE,wBAAwB;EAC/C,eAAe;EACf,SAAS;AACX;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB,EAAE,8BAA8B;EAChD,sCAAsC;AACxC;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,gBAAgB,EAAE,kCAAkC;EACpD,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA,8CAA8C;AAC9C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":["/* /src/components/DNSLookup/DNSLookup.css */\n\n.dnslookup-container {\n  max-width: 500px;\n  margin: 10px auto;\n  padding: 20px;\n  background: #f0f4f8;\n  border-radius: 8px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.dnslookup-title {\n  text-align: center;\n  margin-bottom: 10px;\n  color: #34495e;\n  font-weight: 700;\n  font-size: 1.8rem;\n}\n\n.dnslookup-input {\n  width: 100%;\n  padding: 12px 15px;\n  font-size: 1rem;\n  border: 1.8px solid #3498db;\n  border-radius: 6px;\n  margin-bottom: 15px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box; /* padding এর কারণে উইডথ যেন বেড়ে না যায় */\n}\n\n.dnslookup-input:focus {\n  outline: none;\n  border-color: #2980b9;\n}\n\n.dnslookup-button {\n  width: 100%;\n  padding: 12px;\n  font-weight: 600;\n  background-color: #3498db;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 1.1rem;\n  transition: background-color 0.3s ease;\n}\n\n.dnslookup-button:disabled {\n  background-color: #95a5a6;\n  cursor: not-allowed;\n}\n\n.dnslookup-button:hover:not(:disabled) {\n  background-color: #2980b9;\n}\n\n.dnslookup-results {\n  margin-top: 25px;\n  background: white;\n  border-radius: 6px;\n  padding: 15px 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.dnslookup-record-type {\n  margin-bottom: 20px;\n}\n\n.dnslookup-record-type h4 {\n  color: #2c3e50;\n  margin-bottom: 15px;\n  border-bottom: 2px solid #3498db;\n  padding-bottom: 6px;\n  text-transform: uppercase;\n  font-size: 0.9rem;\n  letter-spacing: 1px;\n}\n\n.dnslookup-record-type ul {\n  list-style-type: none; /* ডট সরিয়ে ফেলা হয়েছে */\n  padding-left: 0;\n  margin: 0;\n}\n\n/* IP Info, ISP Info, Location এর জন্য মেইন কার্ড */\n.dnslookup-ip-item {\n  margin-bottom: 15px;\n  padding: 15px;\n  background: #f8fafc;\n  border-radius: 6px;\n  border-left: 4px solid #3498db;\n  font-size: 0.95rem;\n  line-height: 1.8; /* লাইন স্পেসিং বাড়ানো হয়েছে */\n  box-shadow: 0 1px 3px rgba(0,0,0,0.05);\n}\n\n/* প্রতিটা লাইনকে আলাদা ব্লকে রাখা */\n.dnslookup-ip-item div {\n  margin-bottom: 4px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n/* Label গুলোর জন্য স্টাইল (যেমন: IP Info:) */\n.dnslookup-ip-item strong {\n  color: #34495e;\n  min-width: 100px; /* লেবেলগুলো যেন সমান লাইনে থাকে */\n  display: inline-block;\n}\n\n.dnslookup-no-record {\n  font-style: italic;\n  color: #7f8c8d;\n  padding: 10px 0;\n}\n\n.dnslookup-error {\n  color: #e74c3c;\n  font-weight: 700;\n  text-align: center;\n  padding: 10px;\n}\n\n/* MX বা অন্যান্য সিঙ্গেল লাইন রেকর্ডের জন্য */\n.dnslookup-item-single {\n  padding: 8px 12px;\n  background: #f1f4f6;\n  margin-bottom: 5px;\n  border-radius: 4px;\n  color: #2c3e50;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
